<template>
  <div>
    <v-carousel
      :cycle="true"
      hide-delimiter-background
      hide-delimiters
      :show-arrows="false"
      height="100vh"
    >
      <v-carousel-item
        class="despre-noi-image"
        src="../assets/images/cover.jpg"
        lazy-src="../assets/images/before-show.jpg"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
      <v-overlay :absolute="true" :value="true" style="top: -50%;">
        <v-container :class="styleFontTopic">
          <h2 class="text-on-cover-top">{{text.text1}}</h2>
          <br />
          <h1 class="text-on-cover-bottom">{{text.text2}}</h1>
          <br />
          <h4 style="letter-spacing: 2px;">{{text.text3}}</h4>
        </v-container>
      </v-overlay>
    </v-carousel>
  </div>
</template>

<script>
const axios = require("axios").default;
export default {
  name: "Cover",
  data() {
    return {
      lang: this.$route.params.lang,
      text: {},
      styleFontTopic: {},
      styleFontBody: {}
    };
  },
  methods: {
    loadData() {
      let self = this;
      axios
        .get("/data/cover/" + this.lang + ".json")
        // eslint-disable-next-line no-unused-vars
        .then(function(res) {
          self.text = res.data;
        });
    },
    loadStyle() {
      if (this.lang == "th") {
        this.styleFontTopic = { th: true, "th-cover": true };
        this.styleFontBody = { th: true };
      }
    }
  },
  mounted() {
    this.loadData();
    this.loadStyle();
  },
  watch: {
    lang: function() {
      this.mounted();
      // if(value == 'th') { this.loadData();}
    }
  }
};
</script>

<style scoped>
.text-on-cover-top {
  text-align: center;
  letter-spacing: 2px;
  font-size: 32px;
}
.text-on-cover-bottom {
  text-align: center;
  letter-spacing: 15px;
  font-size: 40px;
  /* padding-bottom: 150%; */
}
.cover-line {
  height: 10px;
  background-color: #b3a258;
}

.despre-noi-image {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center center;
  -webkit-animation: zoomin 10s;
  animation: zoomin 10s;
  animation-fill-mode: both;
  animation-play-state: running;
}

/* @-webkit-keyframes zoomin {
  0% {
    -webkit-transform: scale(1.3);
    transform: scale(1.3);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
} */

@media only screen and (max-width: 567px) {
  .text-on-cover-bottom {
    text-align: center;
    letter-spacing: 5px;
  }
}
@media only screen and (min-width: 1200px) {
  .text-on-cover-bottom {
    text-align: center;
    letter-spacing: 15px;
  }
}
@media only screen and (min-width: 1920px) {
  .text-on-cover-bottom {
    text-align: center;
    letter-spacing: 15px;
  }
}
</style>